/* eslint-disable no-console */
import axios from 'axios'
import { decamelizeKeys } from 'humps'
import { isEmpty, parseJWT } from '../VNUtil/VNUtils'
import Portico from '@ordernext/networking-stadium/portico'
import { nextPosOrderNumber } from '../utils/orderNumbers'

/**
 * A temporary spot to check and apply expired portico tokens if PPI needs to handle this
 */
export const apiCheckAndApplyExpiredPorticoToken = async () => {
  // need to check JWT expiration
  const parsedToken = parseJWT(localStorage.getItem('accessToken'))
  const tokenExpirationMS = parsedToken.exp * 1000
  const timeThreshold = 30000 // 30 seconds

  // is this too closed to be expired
  if (Date.now() - tokenExpirationMS - timeThreshold <= 0) {
    // we need to get a new token
    const deviceId = window.localStorage.device_id
    const appKey = process.env.REACT_APP_OIDC_CLIENT_ID
    const organizationName = process.env.REACT_APP_ORG

    const response = await Portico.deviceLogin(deviceId, appKey, organizationName)

    if (response?.data && response.data.accessToken) {
      localStorage.setItem('accessToken', response.data.accessToken)
    }
  }
}

/**
 * Direct call to orders without going through the saga
 * @param {Array} promotions - Array of all promotions
 * @param {Array} orderMenuItems - formatItems(orderMenuItems)
 * @param {String} standMenuUuid - The stand menu uuid
 * @param {Boolean} isKiosk - is this kiosk or not
 * @param {String} orderUuid - The order UUID is required
 * @returns
 */
export const apiMakePosOrdersTotal = async (promotions, orderMenuItems, standMenuUuid, isKiosk, orderUuid) => {
  // if there are no items, do not attempt total request
  if (isEmpty(orderMenuItems)) return Promise.reject()

  await apiCheckAndApplyExpiredPorticoToken()

  const path = isKiosk ? 'kiosk/v3/orders' : 'pos/orders'

  let requestData = {
    affiliations: [],
    stand_menu_uuid: standMenuUuid,
    uuid: orderUuid,
  }

  if (orderMenuItems) {
    requestData.order_menu_items = decamelizeKeys(orderMenuItems)
  }

  if (promotions) {
    requestData.promotions = decamelizeKeys(promotions)
  }

  return axios.post(`${process.env.REACT_APP_BASE_URL}/${path}/total`, requestData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      'Cache-Control': 'no-cache, no-store',
      Pragma: 'no-cache',
      Expires: 0,
    },
  })
}

export const apiCreateOrder = async (payments, activeAttendantId, orderMenuItems, standMenuUuid, isKiosk, orderUuid) => {
  // if there are no items, do not attempt total request
  if (isEmpty(orderMenuItems)) return Promise.reject()

  await apiCheckAndApplyExpiredPorticoToken()

  const path = isKiosk ? 'kiosk/v3/orders' : 'pos/orders'

  let requestData = {
    stand_menu_uuid: standMenuUuid,
    uuid: orderUuid,
    client_created_at: new Date(),
    order_number: nextPosOrderNumber(),
    payments: payments,
    web_order: true,
    tip_amount_in_cents: 0,
    user_notes: null,
    employee_id: activeAttendantId,
  }

  if (orderMenuItems) {
    requestData.order_menu_items = decamelizeKeys(orderMenuItems)
  }

  console.log(requestData)
  return axios.post(`${process.env.REACT_APP_BASE_URL}/${path}`, requestData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      'Cache-Control': 'no-cache, no-store',
      Pragma: 'no-cache',
      Expires: 0,
    },
  })
}
